var completeImageCount = 0;
function load_complete() {
  completeImageCount++;
  if (2 == completeImageCount) {
    $("#sk-loader").fadeOut();
  }
}

$(
  "#simulation-head, #simulation-headparts, #simulation-shaft, #simulation-shaftparts"
).bind("load", load_complete);

$("#head-color img").on("click", function () {
  $("#head-color img").removeClass("current-slide")
  $(this).addClass("current-slide")
  completeImageCount = 0;
  $("#sk-loader").fadeIn();
  let targetImg = $(this).data("img");
  let targetToeImg = $(this).data("toeimg");
  $("#simulation-head").attr("src", targetImg);
  $("#simulation-headparts").attr("src", targetToeImg);
  $("#color-name-e .headtext").text($(this).attr("alt"));
  $("#head-color li").removeClass("active");
  // $(this).parent().addClass('active');

  localStorage.setItem("headColor", $(this).attr("alt"));
  localStorage.setItem("headImg", targetToeImg);
});

$("#shaft-color img").on("click", function () {
  $("#shaft-color img").removeClass("current-slide")
  $(this).addClass("current-slide")
  completeImageCount = 0;
  $("#sk-loader").fadeIn();

  let targetImg = $(this).data("img");
  $("#simulation-shaft").attr("src", targetImg);
  $("#simulation-shaftparts").attr("src", targetImg);
  $("#color-name-e .shafttext").text($(this).attr("alt"));
  $("#shaft-color li").removeClass("active");
  // $(this).parent().addClass("active");
  
  localStorage.setItem("shaftColor", $(this).attr("alt"));
  localStorage.setItem("shaftImg", targetImg);
});

$(".slider-container .slider-main").slick({
  arrows: true,
  dots: false,
  infinite: true,
  slidesToShow: 11,
  slidesToScroll: 1,
  // focusOnSelect: true,
  // centerMode: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 7,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
});

/* Specific to Beres NX Fairway head color */
$(".slider-container .slider-main2").slick({
  arrows: true,
  dots: false,
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  // focusOnSelect: true,
  // centerMode: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 5,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
});


$('#head-color img').first().click();
$('#shaft-color img').first().click();